export default __webpack_public_path__ + "static/media/img1.ac406817.jpg";